import { Image3 } from "./image3";
import React from "react";

export const Gallery3 = (props) => {
  return (
    <div id="Youtube_thumbnails" className="text-center">
      <div className="container">
        <div className="section-title">
          <br></br><br></br>
          <h1>Motorcycle Thumbnail</h1>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title3}-${i}`}
                    className="col-sm-6 col-md-3 col-lg-4"
                  >
                    <Image3
                      title3={d.title3}
                      largeImage3={d.largeImage3}
                      smallImage3={d.smallImage3}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    
  );
};

